import oitsCommitTypes from './commit-types';
import oitModel from '../../models/oit';
import taskResponseModel from '../../models/task-response';
import trainingPhaseModel from '../../models/training-phase';
import ReducerUtilities from '../../../shared/store/reducer-utilities';

const INITIAL_OITS_STATE = {
  isAssigningFtoFor: null,
  isLoading: [],
  list: null,
  selectedGuid: null,
  taskResponses: null,
  trainingPhases: null,
};

function oitsReducers(state = INITIAL_OITS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case oitsCommitTypes.PUSH_OIT:
      return {
        ...state,
        list: !state.list
          ? [oitModel(action.user)]
          : [...state.list, oitModel(action.user)],
      };
    case oitsCommitTypes.PUSH_OIT_TASK_RESPONSES:
      return {
        ...state,
        taskResponses: [
          ...action.taskResponses.map(item => taskResponseModel(item)),
        ],
      };
    case oitsCommitTypes.PUSH_OITS:
      return {
        ...state,
        list: [...action.list.map(item => oitModel(item))],
      };
    case oitsCommitTypes.PUSH_OIT_TRAINING_PHASES:
      return {
        ...state,
        trainingPhases: [
          ...action.trainingPhases.map(phase => trainingPhaseModel(phase)),
        ],
      };
    case oitsCommitTypes.REPLACE_OIT:
      return {
        ...state,
        list: [
          ...ReducerUtilities.replaceModelInList(
            oitModel(action.oit),
            state.list,
          ),
        ],
      };

    case oitsCommitTypes.UPDATE_TRAINING_TRACKER:

      return {
        ...state,
        list: state.list.map(oit => {
          if (oit.trainingTracker && oit.trainingTracker.trainingTrackerGuid === action.trainingTrackerGuid) {
            return {
              ...oit,
              trainingTracker: {
                ...oit.trainingTracker,
                signActors: action.signActors
              }
            }
          } else {
            return oit
          }
        })
      };
    case oitsCommitTypes.REPLACE_OIT_TRAINING_PHASE:
      return {
        ...state,
        trainingPhases: state.trainingPhases ? [
          ...ReducerUtilities.replaceModelInList(
            trainingPhaseModel(action.trainingPhase),
            state.trainingPhases,
          ),
        ]: state.trainingPhases,
        list: state.list ? state.list.map(({trainingPhases, ...rest}) => {
          return {
            ...rest,
            trainingPhases: trainingPhases.map(tp => {
              if (tp.trainingPhaseGuid === action.trainingPhase.guid) {
                return {
                  trainingPhaseGuid: action.trainingPhase.guid,
                  ...action.trainingPhase.attributes
                }
              } else {
                return tp;
              }
            })
          }
        }) : []
      };
    case oitsCommitTypes.REOPEN_PHASE:
      return {
        ...state,
        trainingPhases: state.trainingPhases ? state.trainingPhases.map(tp =>
          tp.guid === action.phaseGuid
            ? {
              ...tp,
              status: 'opened'
            }: tp)
          : state.trainingPhases,
        list: state.list.map(({trainingPhases, ...rest}) => {
          return {
            ...rest,
            trainingPhases: trainingPhases.map(tp => {
              if(tp.trainingPhaseGuid === action.phaseGuid) {
                return {
                  ...tp,
                  status: 'opened'
                }
              } else {
                return tp;
              }
            })
          }
        })
      };
    case oitsCommitTypes.UPDATE_PHASE_PROJECTED_DATES:
      console.log('ACTIONS', action)
      return {
        ...state,
        trainingPhases: state.trainingPhases ? state.trainingPhases.map(tp =>
          tp.guid === action.phaseGuid
            ? {
              ...tp,
              ...action.projectedDates
            }: tp)
          : state.trainingPhases,
        list: state.list.map(({trainingPhases, ...rest}) => {
          return {
            ...rest,
            trainingPhases: trainingPhases.map(tp => {
              if(tp.trainingPhaseGuid === action.phaseGuid) {
                console.log('FOUND PHASE', action.phaseGuid)
                return {
                  ...tp,
                  ...action.projectedDates
                }
              } else {
                return tp;
              }
            })
          }
        })
      };
    case oitsCommitTypes.RESET_OITS_STATE:
      return { ...INITIAL_OITS_STATE };
    case oitsCommitTypes.SET_OITS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };
    case oitsCommitTypes.SET_SELECTED_OIT_GUID:
      return {
        ...state,
        selectedGuid: action.selectedGuid,
      };
    case oitsCommitTypes.SET_OIT_IS_ASSIGNING_FTO_FOR:
      return {
        ...state,
        isAssigningFtoFor: action.isAssigningFtoFor,
      };
    case oitsCommitTypes.UPDATE_TRAINING_PHASE_HAS_RISK_ALERTS:
      return {
        ...state,
        trainingPhases: state.trainingPhases.map(tp => tp.guid === action.trainingPhaseGuid
        ? {
            ...tp,
            hasRiskAlert: action.hasRiskAlert
          }
        : tp)
      };
    case oitsCommitTypes.UPDATE_PHASE_TRAINING_TRACKER:
      let {phaseGuid, type, ...rest} = action
      return {
        ...state,
        trainingPhases: state.trainingPhases? state.trainingPhases.map(tp => tp.guid === phaseGuid
        ? {
           ...tp,
           ...rest
          }
        : tp): state.trainingPhases,
        list: state.list.map(({trainingPhases, ...r}) => {
          return {
            ...r,
            trainingPhases: trainingPhases.map(tp => {
              if(tp.trainingPhaseGuid === phaseGuid) {
                return {
                  ...tp,
                  ...rest
                }
              } else {
                return tp;
              }
            })
          }
        })
        };
    case oitsCommitTypes.UPDATE_PHASE_START_DATE:
      return {
        ...state,
        trainingPhases: state.trainingPhases.map(tp => tp.guid === action.trainingPhaseGuid
        ? {
            ...tp,
            scheduledTo: action.scheduledTo
          }
        : tp)
      };
    default:
      return state;
  }
}

export default oitsReducers;
